import React from "react";
import AdminLayout from "../../AdminLayout";
import UseUtilityHook from "../hooks/useUtilitiesHook";
import { toast } from "react-toastify";

const AddUtility = () => {
  const {
    register,
    handleSubmit,
    error,
    watch,
    AddSliderImages,
    setAddSliderImages,
    AddMobileSliderImages,
    setAddMobileSliderImages,
    handleSliderFileUpload,
    handleMobileSliderFileUpload,
    handleSliderSubmit,
  } = UseUtilityHook();

  return (
    <div>
      <AdminLayout>
        <div className="add_user_wepper">
          <div className="container">
            <div className="row">
              {/* Form Content */}
              <div className="col-lg-12">
                <div className="add_user_about_me_weepr">
                  <form id="form-1">
                    <div className="add_user_about_me">
                      <h3>Add Slider</h3>
                      <p>Add Slider to Display On Website.</p>
                    </div>
                    <div className="row from_wepper">
                      {/* Slider Title */}
                      <div className="col-lg-6">
                        <div className="form-group ">
                          <label htmlFor="slider_name">
                            Slider Title{" "}
                            <span className="required_text">*</span>
                          </label>
                          <div className="add_user_input">
                            <input
                              type="text"
                              name="slider_name"
                              className="form-control"
                              placeholder="New Year Slider"
                              required="true"
                              {...register("slider_name", {
                                required: true,
                              })}
                              aria-invalid={
                                error.slider_name ? "true" : "false"
                              }
                            />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_771_7773)">
                                <path
                                  d="M12.6667 4.66733C12.6667 7.244 10.5773 9.334 8 9.334C5.42267 9.334 3.33333 7.244 3.33333 4.66733C3.33333 2.08933 5.42267 0 8 0C10.5773 0 12.6667 2.08933 12.6667 4.66733V4.66733ZM11.6013 9.454C10.5973 10.212 9.352 10.6673 8 10.6673C6.64667 10.6673 5.40067 10.2107 4.39533 9.45267C1.68067 10.648 0 14.37 0 16H16C16 14.3847 14.2667 10.6627 11.6013 9.454V9.454Z"
                                  fill="#6F757E"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_771_7773">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          {error.slider_name?.type === "required" && (
                            <p role="alert" className="alert">
                              * Slider Title is required
                            </p>
                          )}
                        </div>
                      </div>

                      {/* slider link */}
                      <div className="col-lg-6">
                        <div className="form-group ">
                          <label htmlFor="slider_link">
                            Slider Link <span className="required_text">*</span>
                          </label>
                          <div className="add_user_input">
                            <input
                              type="text"
                              name="slider_link"
                              className="form-control"
                              placeholder="New Year Slider"
                              required="true"
                              {...register("slider_link", {
                                required: true,
                              })}
                              aria-invalid={
                                error.slider_link ? "true" : "false"
                              }
                            />
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_771_7773)">
                                <path
                                  d="M12.6667 4.66733C12.6667 7.244 10.5773 9.334 8 9.334C5.42267 9.334 3.33333 7.244 3.33333 4.66733C3.33333 2.08933 5.42267 0 8 0C10.5773 0 12.6667 2.08933 12.6667 4.66733V4.66733ZM11.6013 9.454C10.5973 10.212 9.352 10.6673 8 10.6673C6.64667 10.6673 5.40067 10.2107 4.39533 9.45267C1.68067 10.648 0 14.37 0 16H16C16 14.3847 14.2667 10.6627 11.6013 9.454V9.454Z"
                                  fill="#6F757E"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_771_7773">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          {error.slider_link?.type === "required" && (
                            <p role="alert" className="alert">
                              * Slider Link is required
                            </p>
                          )}
                        </div>
                      </div>

                      {/* slider status */}
                      <div className="col-lg-6">
                        <div className="form-group ">
                          <label htmlFor="department">
                            Slider Status{" "}
                            <span className="required_text">*</span>
                          </label>
                          <div className="add_user_input">
                            <select
                              name="slider_status"
                              id="slider_status"
                              className="form-control"
                              {...register("slider_status", {
                                required: true,
                                defaultValue: "",
                              })}
                            >
                              <option value="" disabled>
                                Select Slider Status
                              </option>
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </select>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_771_2040)">
                                <path
                                  d="M14 8.6665V15.3332H10V11.3332H6V15.3332H2V8.6665H0L8 0.666504L16 8.6665H14ZM13.3333 4.7285V1.33317H11.3333V2.7285L13.3333 4.7285Z"
                                  fill="#6F757E"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_771_2040">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          {error.slider_status?.type === "required" && (
                            <p role="alert" className="alert">
                              * Slider Status is required
                            </p>
                          )}
                        </div>
                      </div>

                      {/* slider order */}
                      <div className="col-lg-6">
                        <div className="form-group ">
                          <label htmlFor="department">
                            Slider Order{" "}
                            <span className="required_text">*</span>
                          </label>
                          <div className="add_user_input">
                            <select
                              name="slider_order"
                              id="slider_order"
                              className="form-control"
                              {...register("slider_order", {
                                required: true,
                                defaultValue: "",
                              })}
                            >
                              <option value="" disabled>
                                Select Slider Order
                              </option>
                              <option value="newly_added">Newly Added</option>
                              <option value="important">important</option>
                            </select>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_771_2040)">
                                <path
                                  d="M14 8.6665V15.3332H10V11.3332H6V15.3332H2V8.6665H0L8 0.666504L16 8.6665H14ZM13.3333 4.7285V1.33317H11.3333V2.7285L13.3333 4.7285Z"
                                  fill="#6F757E"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_771_2040">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          {error.slider_order?.type === "required" && (
                            <p role="alert" className="alert">
                              * Slider Order is required
                            </p>
                          )}
                        </div>
                      </div>

                      {/* web slider Image */}
                      <div className="row form_wepper">
                        <div className="col-lg-12">
                          <div className="media_upload_container">
                            <div className="media_preview_row">
                              <label htmlFor="department">
                                Web Slider {"dimension: (1340 x 454) "}
                                <span className="required_text">*</span>
                              </label>
                              {AddSliderImages.map((image, index) => {
                                return (
                                  <div
                                    key={index}
                                    className="media_preview_slot"
                                  >
                                    <img
                                      src={image}
                                      alt={`Uploaded Preview ${index + 1}`}
                                      className="uploaded_image"
                                    />
                                    <button
                                      className="close_icon"
                                      onClick={() => {
                                        setAddSliderImages((prevImages) =>
                                          prevImages.filter(
                                            (_, imgIndex) => imgIndex !== index
                                          )
                                        );
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="13"
                                        height="12"
                                        viewBox="0 0 13 12"
                                        fill="none"
                                      >
                                        <path
                                          d="M6.5 0C3.20445 0 0.5 2.70445 0.5 6C0.5 9.29555 3.20445 12 6.5 12C9.79555 12 12.5 9.29555 12.5 6C12.5 2.70445 9.79555 0 6.5 0ZM9.48312 7.98886L8.48886 8.98312L6.5 6.99427L4.51114 8.98312L3.51688 7.98886L5.50573 6L3.51688 4.01114L4.51114 3.01688L6.5 5.00573L8.48886 3.01688L9.48312 4.01114L7.49427 6L9.48312 7.98886Z"
                                          fill="#313131"
                                        />
                                      </svg>
                                    </button>
                                  </div>
                                );
                              })}
                            </div>
                            <div className="upload_area">
                              <input
                                type="file"
                                name="media"
                                className="file_input"
                                multiple
                                accept="image/jpeg, image/jpg, image/png"
                                onChange={handleSliderFileUpload}
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="65"
                                height="64"
                                viewBox="0 0 65 64"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_900_10944)">
                                  <path
                                    d="M52.444 26.912C51.8787 16.376 43.1827 8 32.5 8C21.82 8 13.1213 16.376 12.556 26.912C5.70267 28.1467 0.5 34.128 0.5 41.3333C0.5 49.432 7.068 56 15.1667 56H49.8333C57.932 56 64.5 49.432 64.5 41.3333C64.5 34.128 59.2973 28.1467 52.444 26.912ZM32.5 24L43.1667 34.6667H35.1667V45.3333H29.8333V34.6667H21.8333L32.5 24Z"
                                    fill="#10849B"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_900_10944">
                                    <rect
                                      width="64"
                                      height="64"
                                      fill="white"
                                      transform="translate(0.5)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <i className="upload_icon"></i>
                              <p>
                                Drop your image here or{" "}
                                <span className="browse_link">Browse</span>
                              </p>
                              <p className="supported_formats">
                                Support: JPG, JPEG, PNG
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* mobile slider Image */}
                      <div className="row form_wepper">
                        <div className="col-lg-12">
                          <div className="media_upload_container">
                            <div className="media_preview_row">
                              <label htmlFor="department">
                                Mobile Slider{"dimension: (364 x 458) "}
                                <span className="required_text">*</span>
                              </label>
                              {AddMobileSliderImages.map((image, index) => {
                                return (
                                  <div
                                    key={index}
                                    className="media_preview_slot"
                                  >
                                    <img
                                      src={image}
                                      alt={`Uploaded Preview ${index + 1}`}
                                      className="uploaded_image"
                                    />
                                    <button
                                      className="close_icon"
                                      onClick={() => {
                                        setAddMobileSliderImages((prevImages) =>
                                          prevImages.filter(
                                            (_, imgIndex) => imgIndex !== index
                                          )
                                        );
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="13"
                                        height="12"
                                        viewBox="0 0 13 12"
                                        fill="none"
                                      >
                                        <path
                                          d="M6.5 0C3.20445 0 0.5 2.70445 0.5 6C0.5 9.29555 3.20445 12 6.5 12C9.79555 12 12.5 9.29555 12.5 6C12.5 2.70445 9.79555 0 6.5 0ZM9.48312 7.98886L8.48886 8.98312L6.5 6.99427L4.51114 8.98312L3.51688 7.98886L5.50573 6L3.51688 4.01114L4.51114 3.01688L6.5 5.00573L8.48886 3.01688L9.48312 4.01114L7.49427 6L9.48312 7.98886Z"
                                          fill="#313131"
                                        />
                                      </svg>
                                    </button>
                                  </div>
                                );
                              })}
                            </div>
                            <div className="upload_area">
                              <input
                                type="file"
                                name="media"
                                className="file_input"
                                multiple
                                accept="image/jpeg, image/jpg, image/png"
                                onChange={handleMobileSliderFileUpload}
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="65"
                                height="64"
                                viewBox="0 0 65 64"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_900_10944)">
                                  <path
                                    d="M52.444 26.912C51.8787 16.376 43.1827 8 32.5 8C21.82 8 13.1213 16.376 12.556 26.912C5.70267 28.1467 0.5 34.128 0.5 41.3333C0.5 49.432 7.068 56 15.1667 56H49.8333C57.932 56 64.5 49.432 64.5 41.3333C64.5 34.128 59.2973 28.1467 52.444 26.912ZM32.5 24L43.1667 34.6667H35.1667V45.3333H29.8333V34.6667H21.8333L32.5 24Z"
                                    fill="#10849B"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_900_10944">
                                    <rect
                                      width="64"
                                      height="64"
                                      fill="white"
                                      transform="translate(0.5)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <i className="upload_icon"></i>
                              <p>
                                Drop your image here or{" "}
                                <span className="browse_link">Browse</span>
                              </p>
                              <p className="supported_formats">
                                Support: JPG, JPEG, PNG
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* submit Button */}
                      <div className="setp_btn row">
                        <div
                          className="col-lg-7 continue_step"
                          style={{ paddingTop: "20px" }}
                          onClick={() => {
                            console.log('add slider length', AddMobileSliderImages.length)
                            console.log('add slider length', AddSliderImages.length)
                            console.log('error length', error)
                            console.log('bool', AddSliderImages.length > 0 && AddMobileSliderImages.length > 0 && !error)
                            AddSliderImages.length > 0 && AddMobileSliderImages.length > 0  ?
                            handleSubmit(handleSliderSubmit)() : toast.error("Please Upload Images or fill data")
                          }}
                        >
                          <p style={{ cursor: "pointer" }} className="active">
                            Submit
                          </p>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminLayout>
    </div>
  );
};

export default AddUtility;
